// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__mpfM-","cross":"Overlay_cross__hvGvs","activeCross":"Overlay_activeCross__Cuic5","activeOverlay":"Overlay_activeOverlay__uGGCx"};